<template>
  <span class="text-inherit">
    <template v-for="(part, index) in parts" :key="index">
      <template v-if="!part.mention">{{ part.text }}</template>
      <el-popover
        v-else
        placement="top"
        :width="320"
        :show-arrow="false"
        :show-after="150"
        :offset="10"
        popper-class="tooltip-placement-top"
        :popper-style="popperStyle"
        trigger="hover"
        :trigger-keys="[]"
        :disabled="!canHover"
      >
        <template #reference>
          <button
            v-if="interactive"
            type="button"
            class="inline cursor-pointer rounded-md px-1.5 py-px font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1"
            :class="
              dark
                ? 'bg-white/20 text-inherit hover:bg-white/30 focus-visible:outline-white'
                : 'bg-primary/10 text-primary hover:bg-primary/20 focus-visible:outline-primary'
            "
            @click="emit('open', part.mention)"
          >{{ part.text }}</button>
          <span
            v-else
            class="rounded-md px-1.5 py-px font-medium"
            :class="dark ? 'bg-white/20 text-inherit' : 'bg-primary/10 text-primary'"
            >{{ part.text }}</span
          >
        </template>
        <ChatPublicationCard :item="part.mention" :hint="interactive" />
      </el-popover>
    </template>
  </span>
</template>

<script setup lang="ts">
  import { useMediaQuery } from "@vueuse/core";
  import type { PublicationMention } from "~/common/chatChannels";

  const props = defineProps<{
    text?: string | null;
    mentions?: PublicationMention[];
    dark?: boolean;
    // Номер открывает публикацию, только если экрану есть где её показать
    interactive?: boolean;
  }>();

  const emit = defineEmits<{ (e: "open", item: PublicationMention): void }>();

  // На телефоне наведения нет: касание номера открыло бы и публикацию, и эту
  // карточку поверх неё. На экранах уже 768px публикация и так открывается модалкой
  const canHover = useMediaQuery("(hover: hover) and (min-width: 768px)");

  // trigger-keys у всплывашки пустой: по умолчанию Enter и пробел открывают её
  // и глушат клик, и номер нельзя было бы открыть с клавиатуры.

  // Как у тултипов оформления заказа (.tooltip-placement-top): тот стиль
  // подключается только вместе с SecondStepOrder, поэтому задаём его здесь
  const popperStyle = {
    background: "#fff",
    borderColor: "#fff",
    padding: "12px",
    borderRadius: "16px",
    boxShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.1)",
  };

  // Тегом становится только @номер публикации этого чата, остальное — обычный текст
  const parts = computed(() => {
    const text = props.text ?? "";
    const byId = new Map((props.mentions ?? []).map((item) => [String(item.id), item]));
    const result: { text: string; mention?: PublicationMention }[] = [];
    let last = 0;
    for (const match of text.matchAll(/@(\d+)/g)) {
      const mention = byId.get(match[1]);
      if (!mention) continue;
      if (match.index! > last) result.push({ text: text.slice(last, match.index) });
      result.push({ text: match[1], mention });
      last = match.index! + match[0].length;
    }
    if (last < text.length) result.push({ text: text.slice(last) });
    return result;
  });
</script>
